export const LOAD_CAMPAIGN_LINKS = 'LOAD_CAMPAIGN_LINKS';
